module.exports = __webpack_public_path__ + "img/rongyu1.56ff0a95.jpg";